module.exports = __webpack_public_path__ + "img/delivery1_4.8b340f06.png";